// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1__b3320fd67246d6d47651","cls2":"NewsInteractionBar-cls2___0b68f50079bfabf6cdb NewsInteractionBar-cls1__b3320fd67246d6d47651"};